export enum ETipoRastreabilidade {
    Nenhum = 0,
    Lote = 1,
    Armamento = 2,
    Veiculo = 3,
    Outros = 4,
}
